import { render, staticRenderFns } from "./BasedOnSection.vue?vue&type=template&id=09514856&scoped=true&"
import script from "./BasedOnSection.vue?vue&type=script&lang=ts&"
export * from "./BasedOnSection.vue?vue&type=script&lang=ts&"
import style0 from "./BasedOnSection.vue?vue&type=style&index=0&id=09514856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09514856",
  null
  
)

export default component.exports